;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="0efc2909-4b43-44f4-82fc-0d193bc8182e",e._sentryDebugIdIdentifier="sentry-dbid-0efc2909-4b43-44f4-82fc-0d193bc8182e")}catch(e){}}();import { CategoryTypeEnum } from '../types/index.js';
import '../_virtual/_sentry-release-injection-file.js';

function isSpecialLink(item) {
    const specialTypes = [
        CategoryTypeEnum.SPECIAL_OFFERS,
        CategoryTypeEnum.NEW_PRODUCTS,
        CategoryTypeEnum.TRIAL_OFFERS,
        CategoryTypeEnum.OUTLET,
    ];
    return item.type ? specialTypes.includes(item.type) : false;
}
function convertTrackingIdTitle(title) {
    return title
        .split(' ')
        .map((substr) => substr.replace(' ', '-'))
        .join('-');
}
function getTrackingId({ type, level, title, index, parentTitle, }) {
    const prefix = 'header-category-flyout-animal';
    if (type === CategoryTypeEnum.SPECIAL_OFFERS) {
        return `${prefix}-special-offer-links-${convertTrackingIdTitle(title)}`;
    }
    if (index !== undefined && parentTitle !== undefined) {
        return `${prefix}-level4-links-${convertTrackingIdTitle(parentTitle)}-${index}-${convertTrackingIdTitle(title)}`;
    }
    return `${prefix}-level${level}-links-${convertTrackingIdTitle(title)}`;
}

export { convertTrackingIdTitle, getTrackingId, isSpecialLink };
//# sourceMappingURL=categoryUtils.js.map
